import FrontBusiness from "@/business/FrontBusiness.js";
import getVar from "@/business/livros/copiladores/getVar.js";
import testarCondicao from "@/business/livros/copiladores/testarCondicao.js";

const ignorarItem = function(remover, dicionarioMerged) {
  for (let fieldPath of Object.keys(remover)) {
    let ids = remover[fieldPath];
    if (ids && ids.length > 0) {
      let valor = getVar(fieldPath, dicionarioMerged, false);
      if (valor !== undefined && valor !== null && ids.includes(String(valor))) {
        return true;
      }
    }
  }
  return false;
};

const repetidor = async function(node, callback, dicionario, debug ){

  let lista = getVar(node.params.lista, dicionario, false);

  if (!Array.isArray(lista)) {
    return '';
  }

  if(node.params.se !== undefined){
    lista = lista.filter(e => testarCondicao(node.params, e));
  }

  const key = node.params.nome || 'item';

  let saida = [];
  let remover = {};

  if(debug) {
    debug.lista = lista;
  }

  for(let item of lista){
    let obj = {};
    obj[key] = item;

    let dicionarioMerged = {...dicionario, ...obj, _remover_: remover, _chave_: key};

    if(Object.keys(remover).length > 0 && ignorarItem(remover, dicionarioMerged)){
      continue;
    }

    if(debug) {
      debug.item = item;
    }
    saida.push(await callback(node.children, dicionarioMerged, debug));
  }

  return FrontBusiness.formatArray(saida, node.params.separador, node.params.ultimo);

};

export default repetidor;
